

















































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import HhAuditService from "@/services/HhAuditService";
import HhAuditChecklistForm from "./HhAuditChecklistForm.vue";
import HhAuditDetail from "./HhAuditDetail.vue";
import UnitRuangPicker, { UnitRuangOption } from "@/components/common/UnitRuangPicker.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";

@Component({
  components: { HhAuditChecklistForm, HhAuditDetail, UnitRuangPicker, PersonAutoComplete }
})
export default class HhAuditList extends Vue {
  // Jenis form audit: "fasilitas" (blok A) atau "kepatuhan" (blok B/C/D + gabungan lama).
  @Prop({ default: "kepatuhan" }) readonly jenis!: "fasilitas" | "kepatuhan";

  mode: "list" | "create" | "logger" | "detail" = "list";
  currentSessionId = 0;

  sessions: any[] = [];
  loading = false;
  creating = false;

  filterTglDari = "";
  filterTglSampai = "";
  filterStatus: string | null = null;
  filterKategori: string | null = null;

  form: any = {
    unit_id: "",
    unit_nama: "",
    tanggal_audit: "",
    waktu_audit: "",
    periode_bulan: new Date().getMonth() + 1,
    periode_tahun: new Date().getFullYear(),
    auditor_nama: "",
    auditor_sip_nik: ""
  };

  statusOptions = [
    { text: "Draft", value: "draft" },
    { text: "TTD Auditor", value: "submitted" },
    { text: "Disetujui Ka. Unit", value: "approved_kaunit" },
    { text: "Disetujui Komite PPI", value: "approved_komite_ppi" },
    { text: "Closed", value: "closed" }
  ];

  kategoriOptions = [
    { text: "BAIK (≥85%)", value: "baik" },
    { text: "CUKUP (75–84%)", value: "cukup" },
    { text: "KURANG (<75%)", value: "kurang" }
  ];

  bulanOptions = [
    { text: "Januari", value: 1 }, { text: "Februari", value: 2 },
    { text: "Maret", value: 3 }, { text: "April", value: 4 },
    { text: "Mei", value: 5 }, { text: "Juni", value: 6 },
    { text: "Juli", value: 7 }, { text: "Agustus", value: 8 },
    { text: "September", value: 9 }, { text: "Oktober", value: 10 },
    { text: "November", value: 11 }, { text: "Desember", value: 12 }
  ];

  get isFasilitas(): boolean {
    return this.jenis === "fasilitas";
  }

  get judul(): string {
    return this.isFasilitas
      ? "Audit Fasilitas Hand Hygiene"
      : "Audit Kepatuhan Hand Hygiene";
  }

  get headers() {
    return [
      { text: "Nomor", value: "nomor_formulir" },
      { text: "Tanggal", value: "tanggal_audit" },
      { text: "Unit", value: "unit_nama" },
      { text: this.isFasilitas ? "Skor Fasilitas" : "Skor Kepatuhan", value: "skor_total" },
      { text: "Kategori", value: "kategori_kepatuhan" },
      { text: "Status", value: "status" },
      { text: "", value: "actions", sortable: false, width: 120 }
    ];
  }

  get canCreate(): boolean {
    return !!(this.form.unit_id && this.form.tanggal_audit &&
      this.form.periode_bulan && this.form.periode_tahun);
  }

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    this.loading = true;
    try {
      const params: any = {};
      // Pemisahan kartu: fasilitas hanya jenis 'fasilitas'; kepatuhan = kepatuhan + gabungan lama.
      if (this.isFasilitas) {
        params.jenis_audit = "fasilitas";
      } else {
        params.jenis_not = "fasilitas";
      }
      if (this.filterTglDari) params.tgl_dari = this.filterTglDari;
      if (this.filterTglSampai) params.tgl_sampai = this.filterTglSampai;
      if (this.filterStatus) params.status = this.filterStatus;
      if (this.filterKategori) params.kategori_kepatuhan = this.filterKategori;
      const res = await HhAuditService.getList({ params });
      this.sessions = res.data.data.data || res.data.data;
    } finally {
      this.loading = false;
    }
  }

  openCreate() {
    this.mode = "create";
    const now = new Date();
    this.form.tanggal_audit = localISODate(now);
    this.form.waktu_audit = now.toTimeString().slice(0, 5);
    this.form.periode_bulan = now.getMonth() + 1;
    this.form.periode_tahun = now.getFullYear();
  }

  onUnitChange(unit: UnitRuangOption | null) {
    this.form.unit_nama = unit ? unit.nama : "";
  }

  async createSession() {
    if (!this.canCreate) return;
    this.creating = true;
    try {
      const res = await HhAuditService.create({ ...this.form, jenis_audit: this.jenis });
      const sess = res.data.data;
      this.currentSessionId = sess.id;
      this.mode = "logger";
    } finally {
      this.creating = false;
    }
  }

  openLogger(item: any) {
    this.currentSessionId = item.id;
    this.mode = "logger";
  }

  openDetail(item: any) {
    this.currentSessionId = item.id;
    this.mode = "detail";
  }

  async returnToList() {
    this.mode = "list";
    await this.loadData();
  }

  printPdf(id: number) {
    HhAuditService.printPdf(id);
  }

  formatDate(s: string) {
    if (!s) return "-";
    const d = new Date(s);
    return d.toLocaleDateString("id-ID");
  }

  getComplianceColor(rate: number) {
    if (!rate && rate !== 0) return "grey";
    if (rate >= 85) return "success";
    if (rate >= 75) return "warning";
    return "error";
  }
}
